export default __webpack_public_path__ + "static/media/full_screen.89c0bc62.svg";